import React from 'react';
import * as S from './Logs.styled';
import { ILog, ILogType } from 'interfaces/main';
import dayjs from 'dayjs';
import { uniq } from 'lodash';
import { Divider, List, Tag } from 'antd';
import { useAppSelector } from 'hooks/useStore';
import { LibrariesSelector } from 'features/Libraries/LibrariesSlice';

export interface Props {
	items: ILog[];
}

const Logs: React.FC<Props> = ({ items }: Props) => {
	// Словари
	const { logTypes: allLogTypes } = useAppSelector(LibrariesSelector);

	const days = uniq(items.map((log: ILog) => dayjs(log.createdAt).format('YYYY.MM.DD')))
		.sort()
		.reverse();

	return (
		<S.Wrap>
			{days.map((date: string) => (
				<>
					<Divider>{dayjs(date, 'YYYY.MM.DD').format('DD.MM.YYYY')}</Divider>
					<List itemLayout="horizontal">
						{items
							.filter((log: ILog) => dayjs(log.createdAt).format('YYYY.MM.DD') === date)
							.sort((a: ILog, b: ILog) => {
								const timeA = dayjs(a.createdAt).format('HH:mm:ss');
								const timeB = dayjs(b.createdAt).format('HH:mm:ss');

								if (timeA < timeB) {
									return -1;
								}
								if (timeA > timeB) {
									return 1;
								}
								return 0;
							})
							.reverse()
							.map((log: ILog) => (
								<List.Item>
									<List.Item.Meta
										avatar={
											<Tag
												bordered={false}
												color={allLogTypes.find((p: ILogType) => p.id === log.logTypeId).antColor}>
												{allLogTypes.find((p: ILogType) => p.id === log.logTypeId).title}
											</Tag>
										}
										title={dayjs(log.createdAt).format('HH:mm:ss')}
										description={log.details}
									/>
								</List.Item>
							))}
					</List>
				</>
			))}
		</S.Wrap>
	);
};

export default Logs;
